export class MeasureConfig {
    isDecimal: boolean;
    isRoundOff: boolean;
    isPercent: boolean;
    isCurrency: boolean;
    decimalPlaces: number;
    isComment: boolean;
    isCalculatedFE: boolean;
    isTotalZero: boolean;
    isSplitPercent: boolean;
    isAveraged: boolean;
    isLowHierarchy: boolean;
    isDc: boolean;
    isCommentZero: boolean;
    isCommentRestrictNegative: boolean;
    showTwoDecimalsBelowOne: boolean;
    constructor() {
      this.isDecimal = false;
      this.isRoundOff = true;
      this.isPercent = false;
      this.isCurrency = false;
      this.decimalPlaces = 0;
      this.isComment = false;
      this.isCalculatedFE = false;
      this.isTotalZero = false;
      this.isSplitPercent = false
      this.isAveraged = false
      this.isLowHierarchy = false
      this.isDc = false
      this.isCommentZero = false
      this.isCommentRestrictNegative = false
      this.showTwoDecimalsBelowOne = false

  }
}
